import React, { useState } from "react";
import { useAuth } from "../../../context/AuthProvider";
import styles from "./RegisterForm.module.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { passwordValidation } from "../../../utils/validations";

const RegisterForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();
  // const { register, loading, error } = useRegister();

  const { register, loading, error } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (password !== confirmPassword) {
        setErrorMessage("Passwords do not match");
        return;
      }
      if (!passwordValidation(password)) {
        setErrorMessage(
          "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one special character (#?!@$%^&*-) and one number."
        );
        return;
      }
      const success = await register(email, password, (error: string) => {
        setErrorMessage(error);
      });
      if (!success) {
        setErrorMessage(error ?? "Registration failed.");
      }
    } catch (error) {
      setErrorMessage("Registration failed.");
    }
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const success = await register(username, email, password);
  //   if (success) {
  //     alert("Registered successfully!");
  //   }
  // };

  return (
    <div>
      <h1 className={styles.heading}>Register</h1>

      <form onSubmit={handleSubmit}>
        <div className={`form-group ${styles.formGroup}`}>
          <label>{t("email")}</label>

          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.inputBox}
            required
          />
        </div>
        <div className={`form-group ${styles.formGroup}`}>
          <label>{t("password")}</label>
          <input
            type="password"
            className={styles.inputBox}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className={`form-group ${styles.formGroup}`}>
          <label>{t("profile.update.security.confirmPassword")}</label>
          <input
            type="password"
            className={styles.inputBox}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        {errorMessage && <div className={styles.errors}>{errorMessage}</div>}
        <button type="submit" className={styles.button}>
          {loading ? "Registering..." : "Register"}
        </button>
      </form>

      <p className={styles.textColor}>
        By login and using Cardonize, you accepted the <a href="/cgu">CGU</a>{" "}
        and confidential polities
      </p>

      <div className="d-flex justify-content-around">
        <Link to="/">Already have an account?</Link>
      </div>
    </div>
  );
};

export default RegisterForm;
